export default "__VITE_ASSET__Cn4FY2XL__"